import { connect } from 'react-redux';
import { isFunction, noop, omit } from 'lodash/fp';
import assert from 'assert';
import React, { PureComponent } from 'react';

import LoadingErrorAlert, { shouldShowLoadingErrorAlert } from '../loading-error-alert';
import LoadingSpinner from '../loading-spinner';

type DataLoaderProps = {
  dispatch: (...args: unknown[]) => unknown;
  history?: {
    push: (...args: unknown[]) => unknown;
  };
  isLoaded?: boolean;
  loadData?: (...args: unknown[]) => unknown;
  loadingError?: {
    code?: string;
    explanation?: string | React.ReactElement;
    response?: string;
  }; // DEPRECATED: not in use for server-side data fetching in NextJS;
  match?: {
    params?: {
      id?: string;
    };
  };
  state: {
    product?: {
      data?: {};
    };
  };
};

const dataLoader = (options = {}) => {
  // @ts-expect-error - Automatic, Please fix when editing this file
  assert(isFunction(options.selectIsDataLoaded), 'selectIsDataLoaded option must be a function');
  // @ts-expect-error - Automatic, Please fix when editing this file
  assert(isFunction(options.selectLoadingError), 'selectLoadingError option must be a function');

  // @ts-expect-error - Automatic, Please fix when editing this file
  const mapStateToProps = (state, props) => ({
    // @ts-expect-error - Automatic, Please fix when editing this file
    isLoaded: options.selectIsDataLoaded(state, props),
    // @ts-expect-error - Automatic, Please fix when editing this file
    loadingError: options.selectLoadingError(state, props),
    state,
  });

  // @ts-expect-error - Automatic, Please fix when editing this file
  const mapDispatchToProps = (dispatch) => ({
    dispatch,
  });

  // @ts-expect-error - Automatic, Please fix when editing this file
  return (WrappedComponent) => {
    class DataLoader extends PureComponent<DataLoaderProps> {
      // DEPRECATED: not in use for server-side data fetching in NextJS
      // @ts-expect-error - Automatic, Please fix when editing this file
      UNSAFE_componentWillMount() {
        const { dispatch, history, loadData, match, state } = this.props;

        // Define loadData prop in top-level routes config ('../../routes/index.jsx')
        if (isFunction(loadData)) {
          // @ts-expect-error - Automatic, Please fix when editing this file
          loadData(state, dispatch, match.params, history);
        }
      }

      // DEPRECATED: not in use for server-side data fetching in NextJS
      // @ts-expect-error - Automatic, Please fix when editing this file
      componentDidUpdate(prevProps) {
        if (prevProps.isLoaded && !this.props.isLoaded) {
          const { dispatch, history, loadData, match, state } = this.props;

          // @ts-expect-error - Automatic, Please fix when editing this file
          loadData(state, dispatch, match.params, history);
        }
      }

      // @ts-expect-error - Automatic, Please fix when editing this file
      render() {
        const { isLoaded, loadingError } = this.props;

        if (!isLoaded) {
          return <LoadingSpinner />;
        }

        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'timeout' does not exist on type '{ code?: string | undefined; explanation?: string | ReactElement<any, string | JSXElementConstructor<any>> | undefined; response?: string | undefined; }'.
        const errorToShow = loadingError?.timeout
          ? { explanation: 'It seems our servers are taking too long to respond. Please try again later.' }
          : loadingError;

        if (shouldShowLoadingErrorAlert(errorToShow)) {
          // @ts-expect-error - Automatic, Please fix when editing this file
          return <LoadingErrorAlert loadingError={errorToShow} />;
        }

        return <WrappedComponent {...omit(['dispatch', 'state'], this.props)} />;
      }
    }

    // @ts-expect-error - Automatic, Please fix when editing this file
    DataLoader.defaultProps = {
      history: {
        push: noop,
      },
      isLoaded: false,
      loadData: null,
      loadingError: null,
      match: {
        params: {
          id: null,
        },
      },
    };

    return connect(mapStateToProps, mapDispatchToProps)(DataLoader);
  };
};

export default dataLoader;
